const KEY = 'checkInOrigin';

export type CheckInOrigin = 'dashboard' | 'kiosk';

export const setCheckInOrigin = (origin: CheckInOrigin): void => {
    try {
        sessionStorage.setItem(KEY, origin);
    } catch {
        // ignore
    }
};

export const getCheckInOrigin = (): CheckInOrigin => {
    try {
        const v = sessionStorage.getItem(KEY);
        return v === 'dashboard' ? 'dashboard' : 'kiosk';
    } catch {
        return 'kiosk';
    }
};

export const clearCheckInOrigin = (): void => {
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        // ignore
    }
};

export const exitPathForOrigin = (): string =>
    getCheckInOrigin() === 'dashboard' ? '/dashboard' : '/kiosk';
